const originalFetch = window.fetch;

window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const token = localStorage.getItem('papacito_token');

  init = init || {};
  const headers = new Headers(init.headers);

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  init.headers = headers;

  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  const isSameOrigin = url.startsWith('/') || url.startsWith(window.location.origin);
  if (isSameOrigin) {
    init.credentials = init.credentials ?? 'include';
  }

  const response = await originalFetch(input, init);

  return response;
};

export {};
